module.exports = __webpack_public_path__ + "static/media/logo_docaposte.0687966e.svg";